/**
 * FE-only Vertrag der Termine-Sektion (SP6) — Typen, UserPreference-Scope-
 * Konstanten und die 14–17-Uhr-Invariante des Systemchecks.
 *
 * SP6 liest diese Scopes nur read-only (E1, migrationsfrei) und validiert
 * NICHTS zur Laufzeit. Die Konstanten/Typen sind bewusst vorwärtskompatibel,
 * damit die spätere „SP-Termine-Aktivierung" (E6) die Save-Logik + Validierung
 * gegen denselben Vertrag bauen kann.
 */

/** UserPreference-Scope des TWV-Blockers (E1, migrationsfrei). Read-only in SP6. */
export const SCOPE_TWV = "profile.schedule.twv" as const;
/** UserPreference-Scope des Systemchecks (E1, migrationsfrei). Read-only in SP6. */
export const SCOPE_SYSTEMCHECK = "profile.schedule.systemcheck" as const;

/** Wochentage Mo–Fr (TWV-Blocker; Wochenende ausgenommen wie PFLICHT_BLOCK_DEFS Mo–Fr). */
export type Weekday = "mon" | "tue" | "wed" | "thu" | "fri";

export const WEEKDAYS: ReadonlyArray<{ id: Weekday; label: string }> = [
  { id: "mon", label: "Mo" },
  { id: "tue", label: "Di" },
  { id: "wed", label: "Mi" },
  { id: "thu", label: "Do" },
  { id: "fri", label: "Fr" },
];

/** TWV-Blocker-Konfiguration (JSON-Form im Scope). Alle Felder optional → Default LEER (E6). */
export interface TwvSchedule {
  /** Angekreuzte Tage. */
  weekdays?: Weekday[];
  /** 'HH:mm'. */
  from?: string;
  /** 'HH:mm'. */
  to?: string;
}

/** Systemcheck-Konfiguration (JSON-Form im Scope). Default LEER. */
export interface SystemcheckSchedule {
  /** 'HH:mm'. */
  from?: string;
  /** 'HH:mm'. */
  to?: string;
}

/**
 * INVARIANTE Systemcheck-Fenster: NUR 14–17 Uhr (Vorplan §6).
 *
 * SP6 belegt NICHTS damit vor und validiert NICHT zur Laufzeit — die Konstante
 * dokumentiert nur die Regel.
 *
 * TODO(SP-Termine-Aktivierung): Bei Aktivierung `from`/`to` gegen
 * [SYSTEMCHECK_WINDOW.min, SYSTEMCHECK_WINDOW.max] (14–17 Uhr) validieren.
 */
export const SYSTEMCHECK_WINDOW = { min: "14:00", max: "17:00" } as const;
